/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";
import { useCurrency } from "~/hooks";
import { currencies } from "~/tools";
import { getNumberFilterValue } from "../helpers";
import { NumberRangeInput } from "../NumberRangeInput";
import { FiltersProp } from "../types";

type Props = {
  filters: FiltersProp;
  updateFilters: (input: FiltersProp) => void;
  size?: "m" | "s";
};

export function CostInput({ filters, updateFilters, size }: Props) {
  const { currency } = useCurrency();
  const options = currencies;

  return (
    <>
      <div
        style={{
          whiteSpace: "nowrap",
          marginTop: `${theme.spacing.spacing04}`,
        }}
      >
        <div style={{ display: "inline-block" }}>
          <NumberRangeInput
            from={filters.costFrom}
            to={filters.costTo}
            size={size}
            onChangeFrom={(value) =>
              updateFilters({
                costFrom: getNumberFilterValue(value),
              })
            }
            onChangeTo={(value) =>
              updateFilters({
                costTo: getNumberFilterValue(value),
              })
            }
          />
        </div>
        <span>{options.find((curr) => curr.iso === currency)?.symbol}</span>
      </div>
    </>
  );
}
